import FunctionsIcon from '@mui/icons-material/Functions';

import DataSetList from './DataSetList';
import DataSetCreate from './DataSetCreate';
import DataSetShow from './DataSetShow';

export default {
    list: DataSetList,
    create: DataSetCreate,
    show: DataSetShow,
    icon: FunctionsIcon,
};
